module.exports = __webpack_public_path__ + "img/small-screen.b530efeb.png";